export default __webpack_public_path__ + "static/media/complete-solution.59969257.svg";